export default "__VITE_ASSET__CnHTparF__"